import config from "environment";
import { getRequest, postRequest } from "./client";
import {
  WorkspaceScenarioWithEvaluation,
  WorkspaceScenarioEvaluation,
  SubmitWorkspaceEvaluationsContract,
} from "winslow-core";

const { baseApi } = config;

export async function getWorkspaceScenarioEvaluations(
  workspaceId: string,
  email: string
): Promise<WorkspaceScenarioWithEvaluation[] | null> {
  const fetchURL =
    `${baseApi}/workspace-evaluations?workspaceId=${encodeURIComponent(
      workspaceId
    )}&email=${encodeURIComponent(email)}`;

  return await getRequest<WorkspaceScenarioWithEvaluation[]>(
    fetchURL,
    "API/getWorkspaceScenarioEvaluations"
  );
}

export async function submitWorkspaceScenarioEvaluations(
  payload: SubmitWorkspaceEvaluationsContract["Body"]
): Promise<WorkspaceScenarioEvaluation[] | null> {
  const fetchURL = `${baseApi}/workspace-evaluations`;

  return await postRequest<
    SubmitWorkspaceEvaluationsContract["Body"],
    WorkspaceScenarioEvaluation[]
  >(fetchURL, payload, "API/submitWorkspaceScenarioEvaluations");
}
